// @ts-check
/// <reference path="./types.js" />
import { createReducer } from "@reduxjs/toolkit";
import {
  paginateRdmsFailure,
  paginateRdmsSuccess,
  paginateRdmsRequest,
} from "./actions";
import "./types";

/**
 * Reducer para o estado de RDMs, incluindo paginação e loading.
 * @param {RdmState} state
 * @param {import("@reduxjs/toolkit").AnyAction} action
 * @returns {RdmState}
 */

/** @type {RdmState} */
const initialState = {
  data: [],
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 1,
  loading: false,
  error: null,
};

const rdmReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(paginateRdmsRequest, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(paginateRdmsSuccess, (state, action) => {
      /** @type {RdmState} */
      const payload = /** @type {RdmState} */ (action.payload ?? {});
      state.data = payload.data || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.total = payload.total || 0;
      state.totalPages = payload.totalPages || 1;
      state.loading = false;
      state.error = null;
    })
    .addCase(paginateRdmsFailure, (state, action) => {
      state.loading = false;
      state.error = "Erro ao paginar RDMs";
    });
});

export default rdmReducer;
